import styled from 'styled-components';

export const MenuFooter = styled.div`
  display: flex;
  align-items: center;
  background-color: #fff;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  box-sizing: border-box;
  padding: 10px 12px;
  border-radius: 0 0 4px 4px;
  border-top: 1px solid #eee;
`;
